import { LeftRight } from "@/components/LeftRight.tsx";
import { type ConfiguredWSelectProps, WSelect } from "@/components/forms/WSelect.tsx";
import { WSelectWrapper } from "@/components/forms/WSelectWrapper.tsx";
import { ResourceIcon } from "@/components/icon/ResourceIcon.tsx";
import { firewallQueryAtom, type FirewallWithType } from "@/modules/network/firewall/firewallApi.ts";
import { useSuspenseQueryAtom } from "@/utils/query/useSuspenseQueryAtom.ts";

export interface FirewallSelectProps extends ConfiguredWSelectProps<FirewallWithType, string> {
    location: string;
    vmUuid?: string;
}

function FirewallSelectCustom({ vmUuid, items, location, ...props }: FirewallSelectProps) {
    const { onChange } = props;

    items = items.filter(
        (item) =>
            location === item.location &&
            !item.resources_assigned?.some((resource) => resource.resource_uuid === vmUuid),
    );

    return (
        <WSelect
            className="min-w-20em"
            aria-label="Select resource"
            items={items}
            getKey={(item) => item.uuid}
            getTextValue={(item) => item.display_name}
            searchItems
            onChange={onChange}
            {...props}
        >
            {(item) => <LeftRight icon={<ResourceIcon item={item} />} title={item.display_name} />}
        </WSelect>
    );
}

export type FirewallSelectLoaderProps = Omit<FirewallSelectProps, "items">;

function FirewallSelectLoader(props: FirewallSelectLoaderProps) {
    const firewalls = useSuspenseQueryAtom(firewallQueryAtom(props.location));

    return <FirewallSelectCustom items={[...firewalls.values()]} {...props} />;
}

export function FirewallSelect(props: FirewallSelectLoaderProps) {
    return (
        <WSelectWrapper fallback={(renderProps) => <FirewallSelectCustom {...props} {...renderProps} />}>
            <FirewallSelectLoader {...props} />
        </WSelectWrapper>
    );
}
